import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { Capacitor } from '@capacitor/core';
import PortalLayout, { card } from '../components/PortalLayout';

const A = '#00D4AA';

export default function ScanObject() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [scanning, setScanning] = useState(false);
  const [supported, setSupported] = useState(true);
  const [laatste, setLaatste] = useState(null);

  useEffect(() => {
    (async () => {
      if (!Capacitor.isNativePlatform()) { setSupported(false); return; }
      try {
        const r = await BarcodeScanner.isSupported();
        setSupported(!!r.supported);
      } catch { setSupported(false); }
    })();
  }, []);

  const verwerk = (code) => {
    setLaatste(code);
    const m = code.match(/[?&]klant=(\d+)/);
    if (m) { navigate('/object/' + m[1]); return; }
    if (/^\d+$/.test(code)) { navigate('/object/' + code); return; }
    setError('Onbekende QR-code. Scan de sticker op het object.');
  };

  const startScan = async () => {
    setError(null); setLaatste(null);
    if (!Capacitor.isNativePlatform()) {
      setError('De scanner werkt alleen in de app, niet in de browser.');
      return;
    }
    try {
      const { camera } = await BarcodeScanner.requestPermissions();
      if (camera !== 'granted') {
        setError('Camera-toegang geweigerd. Geef toegang via Instellingen \u2192 Apps \u2192 WOMsys Klantportaal \u2192 Machtigingen.');
        return;
      }
      setScanning(true);
      const { barcodes } = await BarcodeScanner.scan();
      if (barcodes && barcodes.length > 0) {
        verwerk(barcodes[0].rawValue);
      } else {
        setError('Geen QR-code herkend.');
      }
    } catch (err) {
      setError('Scan mislukt: ' + (err.message || 'onbekende fout'));
    } finally {
      setScanning(false);
    }
  };

  return (
    <PortalLayout titel="Object scannen">
      {!supported && (
        <div style={{ background: '#fef3c7', border: '1px solid #fbbf24', borderRadius: 12, padding: 24, marginBottom: 10, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>&#9888;&#65039;</div>
          <div style={{ fontWeight: 700, color: '#1e293b' }}>Niet beschikbaar</div>
          <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>De scanner werkt alleen in de WOMsys-app op je telefoon, niet in de browser.</div>
        </div>
      )}
      {supported && (
        <div style={{ ...card, textAlign: 'center', padding: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 10 }}>&#128247;</div>
          <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 16 }}>Scan de QR op het object</div>
          <div style={{ color: '#64748b', fontSize: 13, margin: '6px 0 18px' }}>Richt de camera op de sticker &mdash; je gaat dan meteen naar de gegevens van dat object.</div>
          <button onClick={startScan} disabled={scanning} style={{ background: A, color: '#062b24', border: 'none', borderRadius: 10, padding: '14px 24px', fontWeight: 700, fontSize: 15, cursor: scanning ? 'default' : 'pointer' }}>
            {scanning ? 'Scanner geopend\u2026' : '\uD83D\uDCF7 Camera openen'}
          </button>
        </div>
      )}
      {error && (
        <div style={{ background: '#fee2e2', border: '1px solid #ef4444', borderRadius: 12, padding: 14, marginBottom: 10 }}>
          <div style={{ color: '#b91c1c', fontWeight: 600, fontSize: 14 }}>{error}</div>
          {laatste && <div style={{ color: '#64748b', fontSize: 12, marginTop: 6, wordBreak: 'break-all' }}>Gescand: {laatste}</div>}
        </div>
      )}
    </PortalLayout>
  );
}
